import { Component, OnInit } from '@angular/core';
import { IHeaderParams } from 'ag-grid-community/dist/lib/headerRendering/header/headerComp';
import { IHeaderAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-agg-widget-header',
  templateUrl: './agg-widget-header.component.html',
  styleUrls: ['./agg-widget-header.component.scss']
})
export class AggWidgetHeaderComponent implements OnInit, IHeaderAngularComp {

  public params: any;
  public refresh: (params: IHeaderParams) => boolean;

  constructor() { }

  public ngOnInit() {
  }

  // equivalent of init in IHeaderComp
  // IHeaderCompParams is same as non Angular version
  public agInit(params: ICaseWidgetHeaderParams): void {
    this.params = params;
  }

  // no getGui() or destroy(), all handled by Angular

  public onMenuClicked(): void {
    // not implemented
  }

  public onSortChanged() {
    // not implemented
  }

  public onSortRequested(order, event) {
    // not implemented
  }

  public btnClicked(): void {
    this.params.callbackFn();
  }
}

export interface ICaseWidgetHeaderParams extends IHeaderParams {
  agMatIconName: string;
  callbackFn: () => any;
}

